// @flow

import * as React from 'react';
import type {IntegrationCheckersDataIntegrationCheckResult} from '../../generatedTypes';

/**
 * Renders the View request link and CheckerErrors list for
 * in-line integration checks in the guide as well as
 * the checks in the "Test your integration" section
 */
type InlineIntegrationCheckProps = {
  check: IntegrationCheckersDataIntegrationCheckResult,
  // when we need to show a different type of object we can
  // make this prop more generic
  paymentIntentId: string,
  showLink: boolean,
  children?: React.Node,
  dashboardUrl: string,
};
const InlineIntegrationCheck = (props: InlineIntegrationCheckProps) => {
  const {check, showLink, dashboardUrl, paymentIntentId} = props;
  return (
    <div className="inline-check-container">
      {props.children || (paymentIntentId && showLink) ? (
        <div className="inline-check">
          {props.children}
          {paymentIntentId && showLink ? (
            <a
              className="log-link"
              target="_blank"
              rel="noopener noreferrer"
              href={
                check
                  ? `${dashboardUrl}/test/payments/${paymentIntentId}`
                  : null
              }
            >
              View in Dashboard.
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

type InlineIntegrationCheckAsideProps = {
  check: IntegrationCheckersDataIntegrationCheckResult,
  dashboardUrl: string,
  paymentIntentId: string,
};

/**
 * The gray banner to show the InlineIntegrationCheck along
 * with an exclamation point icon or green check depending on
 * the result
 */
const InlineIntegrationChecker = (props: InlineIntegrationCheckAsideProps) => {
  const {check, dashboardUrl, paymentIntentId} = props;
  if (!check || !check.success) {
    return null;
  }
  const message = "You've successfully completed this step.";
  return (
    <aside
      className={`important ${
        check.success ? 'check' : ''
      } inline-integration-checker-aside`}
    >
      <InlineIntegrationCheck
        check={check}
        showLink={check.success}
        dashboardUrl={dashboardUrl}
        paymentIntentId={paymentIntentId}
      >
        {message}
      </InlineIntegrationCheck>
    </aside>
  );
};

export default InlineIntegrationChecker;
